import moment from 'moment';

export const getCalendarDates = (date: Date) => {
	const fromDate = moment(date).startOf('week').format('YYYY-MM-DD');
	const toDate = moment(date).endOf('week').format('YYYY-MM-DD');

	return { fromDate, toDate };
};
